<template>
  <div class="flex items-center gap-3 p-4 justify-between">
    <select
      v-model="filterType"
      class="border border-gray-300 p-2 rounded-md w-200"
      @change="emitFilter"
    >
      <option value="days">{{ $t('group-per-days') }}</option>
      <option value="weeks">{{ $t('group-per-weeks') }}</option>
    </select>

    <div>
      <label class="text-gray-700 font-medium">
        {{ $t('start') }}:
      </label>

      <input
        type="date"
        v-model="startDate"
        class="border border-gray-300 p-2 rounded-md"
        :max="endDate || today"
        @change="emitFilter"
      />

      <label class="text-gray-700 font-medium">
        {{ $t('end') }}:
      </label>

      <input
        type="date"
        v-model="endDate"
        class="border border-gray-300 p-2 rounded-md"
        :min="startDate"
        :max="today"
        @change="emitFilter"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PeriodFilterMenu",
  props: {
    batch: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: "days"
    }
  },
  data() {
    return {
      filterType: this.value,
      startDate: new Date(
        Date.now() - 7 * 24 * 60 * 60 * 1000
      ).toISOString().slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
    today: new Date().toISOString().slice(0, 10)
    };
  },
  methods: {
      emitFilter() {
        this.$emit("filter-change", {
          id: this.batch.id,
          start: this.startDate,
          end: this.endDate
        });

        this.$emit("input", this.filterType);
      }
  }
};
</script>
